
import React from "react";
import { PartFilter, PartSubcategory } from "@/data/parts";
import { FilterBadge } from "@/components/shared";

interface SpecialFiltersBadgesProps {
  activeFilters: PartFilter[];
  toggleFilter: (filter: PartFilter) => void;
  selectedSubcategory: PartSubcategory | "all";
}

const SpecialFiltersBadges = ({ 
  activeFilters, 
  toggleFilter, 
  selectedSubcategory 
}: SpecialFiltersBadgesProps) => {
  // Determine which filters should be shown based on selected subcategory
  const showEddyCurrentFilter = selectedSubcategory === "all" || selectedSubcategory === "probe";
  const showClickyFilter = selectedSubcategory === "all" || selectedSubcategory === "probe";
  const showUnicornFilter = selectedSubcategory === "all" || selectedSubcategory === "hotend";
  
  const specialFilters = [
    {
      filter: "upgrade" as PartFilter,
      label: "Upgrade",
      type: "upgrade" as const,
      show: true
    },
    {
      filter: "eddy-current" as PartFilter,
      label: "Eddy Current",
      type: "eddy-current" as const,
      show: showEddyCurrentFilter
    },
    {
      filter: "clicky" as PartFilter,
      label: "Clicky",
      type: "clicky" as const,
      show: showClickyFilter
    },
    {
      filter: "unicorn" as PartFilter,
      label: "Unicorn",
      type: "unicorn" as const,
      show: showUnicornFilter
    },
    {
      filter: "stock" as PartFilter,
      label: "Stock",
      type: "stock" as const,
      show: true
    }
  ];

  return (
    <div className="flex flex-wrap gap-2 px-2">
      {specialFilters
        .filter(({ show }) => show)
        .map(({ filter, label, type }) => (
          <FilterBadge
            key={filter}
            type={type}
            active={activeFilters.includes(filter)}
            onClick={() => toggleFilter(filter)}
            tooltip={`Toggle ${label.toLowerCase()} filter`}
            className="truncate max-w-full"
            aria-label={`${activeFilters.includes(filter) ? 'Remove' : 'Add'} ${label} filter`}
          >
            {label}
          </FilterBadge>
        ))}
    </div>
  );
};

export default SpecialFiltersBadges;
